import Navbar from "../components/Navbar";
import BookHero from "../components/Book/BookHero";
import BookAbout from "../components/Book/BookAbout";
import BookServices from './../components/Book/BookServices';
import BookReview from "../components/Book/BookReview";
import BookContact from "../components/Book/BookContact";
import BookFAQ from "../components/Book/BookFAQ";
import BookFooter from "../components/Book/BookFooter";


export default function BookAppointment() {
    return (
        <>
            <Navbar />
            <div className="relative">
                {/* Hero Section (loads first) */}
                <BookHero />
                <BookServices />
                <BookAbout />
                <BookReview />
                <BookContact />
                <BookFAQ />
                <BookFooter />

            </div>
        </>
    );
}
